var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('v-container',{attrs:{"fluid":""}},[_c('search-navigation'),_c('table-tabs')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }